// This section name, must match the name coming from partner-orchestrator
export const P2P_RELATIONS_SECTION_NAME = 'Partner to Partner Relations';

export const P2P_RELATIONS_EDIT_HISTORY_HIDDEN_ATTRIBUTES = [
  'PartnerToPartnerRelationDto/relatedPartnerUId',
  'PartnerToPartnerRelationDto/relationUId',
];
